import * as React from 'react'
import { Link } from 'DVWebNodeUI'
import { NavLink } from 'DVWebNodeUtils'
import * as cn from 'classnames'

export interface MenuProps {
  text: string,
  links: NavLink[],
  isElcano: boolean
}

export const MainMenu = ({text, links, isElcano}: MenuProps) => {
  const listItems = links.map((linkProps, i) => (
    <li key={i}>
      <Link {...linkProps}
        className={cn({'pv-highlighted': linkProps.isHighlighted})}
        key={linkProps.text} />
    </li>
  ))
  return (
    <div id="pv-nav-main-menu" className={cn('pv-nav-main-menu', {'pv-nav-main-menu-elcano': isElcano})}>
      <input type="checkbox" autoComplete="off" id="pv-nav-main-menu-trigger"
        className="pv-nav-main-menu-switch avu-screen-reader-only" />
      <label htmlFor="pv-nav-main-menu-trigger" className="pv-nav-main-menu-label">
        {text}
      </label>
      <ul role="navigation">
        {listItems}
      </ul>
    </div>
  )
}
